// extracted by mini-css-extract-plugin
export var button = "Button-module--button--S4liN";
export var primary = "Button-module--primary--1za6K";
export var primaryWhite = "Button-module--primaryWhite--VMrvd";
export var secondaryWhite = "Button-module--secondaryWhite--AnA0P";
export var squareContained = "Button-module--squareContained--1roM3";
export var squareOutlined = "Button-module--squareOutlined--Tegkq";
export var unactive = "Button-module--unactive--WjKau";
export var bigger = "Button-module--bigger--Ja5xn";
export var loading = "Button-module--loading--oqKW+";